export const REFRESH_PHOTOS = 'REFRESH_PHOTOS';
export const SET_PHOTOS = 'SET_PHOTOS';
export const ADD_PHOTO = 'ADD_PHOTO';
export const UPDATE_PHOTO = 'UPDATE_PHOTO';
export const GET_PHOTO = 'GET_PHOTO';
export const FINISH_GET_PHOTO = 'FINISH_GET_PHOTO';
export const DELETE_PHOTO = 'DELETE_PHOTO';
